<template>
  <div id="illustrations">
    <!-- <img src="@/assets/gel/images/illustrations/group.svg"/> -->
    <div class="card border-0">
      <h2 class="sg mt-0">Hero</h2>
      <p class="text-16">Hero illustrations are intended to tell more complex stories. This allows them to be more metaphorical and fantastical in nature.</p>
      <img src="@/assets/gel/images/illustrations/hero.svg"/>
      <h2 class="sg">Spot Hero</h2>
      <p class="text-16">Spot heroes are slightly simplified versions of heroes, visually and metaphorically. These assets are perfect when you need to pack a punch with limited space. Often, they are a slightly more literal representations of a single concept. </p>
      <div class="row">
        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="200" src="@/assets/gel/images/illustrations/error.svg"/></div>
        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="200" src="@/assets/gel/images/illustrations/empty-state.svg"/></div>
        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="200" src="@/assets/gel/images/illustrations/empty2.svg"/></div>
        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="200" src="@/assets/gel/images/illustrations/spot-hero.svg"/></div>
        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="200" src="@/assets/gel/images/illustrations/handshake.svg"/></div>
        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="200" src="@/assets/gel/images/illustrations/screening.svg"/></div>
        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="200" src="@/assets/gel/images/illustrations/onboarding.svg"/></div>
        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="200" src="@/assets/gel/images/illustrations/onboarding2.svg"/></div>

        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="200" src="@/assets/gel/images/illustrations/celebrate.svg"/></div>
        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="200" src="@/assets/gel/images/illustrations/ideation.svg"/></div>
        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="175" src="@/assets/gel/images/illustrations/candidate.svg"/></div>
        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="175" src="@/assets/gel/images/illustrations/exit.svg"/></div>

        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="200" src="@/assets/gel/images/illustrations/teamwork.svg"/></div>
        <div class="col-sm-6 col-xxl-4 mb-7 text-center"><img width="200" src="@/assets/gel/images/illustrations/maintenance.svg"/></div>
      </div>  
      <h2 class="sg">Spot</h2>
      <p class="text-16">Spot illustrations are the simplest and most literal expression of a concept. </p>
        <div class="row">
          <div class="col-3 col-md-2 mb-5 text-center"
            v-for="illustration in searchIconsMatch"
            :key="illustration"
          >
            <Illustration :iconName="illustration"></Illustration>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Illustration from '@/components/icons/Illustration.vue'
import illustrations from '@/components/icons/illustrations.js'

let description = 'Illustrations'

export default {
  name: 'Illustrations',
  components: {
    Illustration
  },
  data () {
    return {
      illustrations,
    }
  },
  beforeCreate: function () {
    this.$emit('update-icon-name', this.$options.name, this.$options.name) 
    this.$emit('update-icon-description', this.$options.name, description) 
    this.$emit('update-icon-number-of-icons', this.$options.name, illustrations.length)
  },
  computed: {
    searchIconsMatch: function () {
      this.$emit('search-icons', this.$options.name, this.illustrations)
      if (this.searchResult['name'] === this.$options.name) {
        this.$emit('update-icon-number-of-icons', this.$options.name, this.searchResult['result'].length)
        return this.searchResult['result']
      }
      return illustrations
    }
  },
  props: {
    searchResult: Object
  }
}
</script>